export enum TimesheetReportType {
  ENTRY = 'Entry',
  TIME_OFF_BOTH = 'Time Off Paid and Unpaid',
  TIME_OFF_PAID = 'Time Off Paid',
  TIME_OFF_UNPAID = 'Time Off Unpaid',
  ENTRY_AND_TIME_OFF_PAID = 'Entry and Time Off Paid',
  ENTRY_AND_ALL_TIME_OFF = 'Entry and All Time Off',
}
